import { classifySortords } from 'json/information-options'
// 新闻页面顶部筛选tab
export let newsTabLabels = [
  {
    label: '新闻类型',
    type: 'select',
    value: 'categoryId',
    clearable: true,
    props: {
      label: 'name',
      value: 'id'
    },
    options: []
  },
  {
    label: '发布时间',
    type: 'time-slot',
    value: 'publishDate',
    startName: 'publishStartDate',
    endName: 'publishEndDate',
    clearable: true
  },
  {
    label: '新闻状态',
    type: 'select',
    value: 'newsState',
    clearable: true,
    options: [
      {
        label: '已下架',
        value: 'DISABLED'
      },
      {
        label: '已发布',
        value: 'PUBLISHED'
      },
      {
        label: '未发布',
        value: 'DRAFT'
      }
    ]
  }
]
// 新闻列表表头
export let tableLabels = [
  {
    label: '浏览量',
    value: 'visitorVolume'
  },
  {
    label: '新闻类型',
    value: 'categoryName'
  },
  {
    label: '发布时间',
    value: 'publish_date'
  },
  {
    label: '发布人',
    value: 'publisher.name'
  }
  // {
  //   label: '状态',
  //   value: 'news_state'
  // }
]
// 新闻分类表格label
export let classifyTableLabel = [
  {
    label: '分类名称',
    value: 'name'
  },
  {
    label: '新闻数量',
    value: 'extensionInfo.newsCount'
  },
  {
    label: '新闻排序',
    value: 'sort'
  },
  {
    label: '创建时间',
    value: 'created_date'
  }
]

// 新闻分组内排序方式
export let classifySortord = classifySortords
